export default function (element, data) {
    window.addEventListener("open-popup-grass", function (e) {
        let itemData = e.detail.dataset;

        if (itemData.grass_id && itemData.is_open) {
            let grasssItems = element.querySelectorAll('.grass__popup_content .grass__item');
            grasssItems.forEach(item => {
                if (item.dataset.grass_id == itemData.grass_id) {
                    item.classList.add('open');
                } else {
                    item.classList.remove('open');
                }
                
            });

            // setTimeout(() => {
                element.classList.add("open");
                document.body.classList.add('no-scroll');
            // }, 500);
        }
        
    });
    window.addEventListener("close-popup-grass", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-popup-grass'));
    });
    element.querySelector(".grass__popup_block").addEventListener("click", function (event) {
        event.stopPropagation();
    });
}
